@if (!page()) {
  <div class="more-info-group">
    <div class="more-info-subgroup">
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:flange"
          svgIconRight="icons:arrow-right"
          (click)="toFlangeDocuments()"
          (keyup)="toFlangeDocuments()"
          tabindex="0"
        >
          {{ i18n.langString("flange") }}
        </app-more-info>
      </button>
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:steamtrap"
          svgIconRight="icons:arrow-right"
          (click)="toSteamtrapDocuments()"
          (keyup)="toSteamtrapDocuments()"
          tabindex="0"
        >
          {{ i18n.langString("steamtrap") }}
        </app-more-info>
      </button>
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:rotatingEqu"
          svgIconRight="icons:arrow-right"
          (click)="toRotatingequipmentDocuments()"
          (keyup)="toRotatingequipmentDocuments()"
          tabindex="0"
        >
          {{ i18n.langString("rotatingequipment") }}
        </app-more-info>
      </button>
    </div>
  </div>
} @else {
  @for (docType of availableDocTypes(); track docType) {
    <div class="card" [class.mobile]="isMobile()" [class.tablet]="isTablet()">
      <nz-card>
        <div class="card-header bottom-space">
          <i nz-icon class="inline-error-icon" nzType="icons:document"></i>
          <h4>{{ i18n.langString("doctype_label_" + docType) }}</h4>
        </div>

        @if (availableLanguages()[docType].length > 1) {
          <div class="bottom-space">
            <div class="detail">{{ i18n.langString("select_language") }}</div>
            <!-- <app-select [options]="availableLanguages()[docType]" [(selected)]="selectedLanguages()[docType]"
                [placeholder]="i18n.langString('select_language')" [disabled]="false" [optional]="false"></app-select> -->
          </div>
        }
        <app-nav-button
          [primary]="true"
          svgIcon="icons:eye"
          (clickEvent)="openDocument(docType)"
        >
          {{ i18n.langString("show_document") }}
        </app-nav-button>
      </nz-card>
    </div>
  }
}
